
import $pulse from 'stores/pulse'

export default {
  props: {
    show: {type: Boolean, default: false},
    size: {type: String, default: '1.2rem'},
    teleported: {type: Boolean, default: false},
    itemId: {type: String, default: undefined},
    pulseItem: {type: Object, default: undefined}
  },
  emits: ['show'],
  data() {
    return {
      // computed causes errors when item is removed, so we use data
      item: this.pulseItem || $pulse.getItem(this.itemId) 
    }
  },
  computed: {
    liked(){
      return this.item.liked > 0
    },
    disliked(){
      return this.item.liked < 0
    },
    favorite: {
      get(){
        return this.item.favorite
      },
      set(){
        this.item.favorite = !this.item.favorite
      }
    },

    c_show() {
      return this.show || this.liked || this.disliked || this.favorite
    }
  },
  watch: {
    favorite(){
      this.$debounce(this.save)
    }
  },
  methods: {
    onLike(feedback) {
      this.item.like(feedback)
    },
    async onDislike(feedback) {
      await this.item.dislike(feedback)
      if (this.disliked) this.$dispatch('disliked', this.item.id)
    },
    async save() {
      await this.item.save()
      if (!this.favorite) this.$dispatch('unfavor', this.item.id)
    }
  }
}
